<ng-container *ngIf="fund$ | async as fund">
  <section class="container information">
    <!-- Images -->
    <div class="terra-card images-card">
      <terra-holding-images [singleLineAddress]="true" [location]="fund.location"
                            [holdingFiles]="fund.attachments" />
    </div>

    <!-- Asset details box -->
    <div class="terra-card holding-details">
      <div class="card-header">
        <h2>Fund info</h2>
      </div>
      <ul class="basic-info-list">
        <!-- Investment strategy -->
        @if(fund.investmentStrategyType)
        {
          <li class="basic-info-item">
            <mat-icon class="notranslate" svgIcon="pie_chart_quarter"></mat-icon>
            <label>Investment strategy:</label>
            <span class="value">{{ fund.investmentStrategyType | enumString: InvestmentStrategyType }}</span>
          </li>
        }

        <!-- Total capitalization -->
        <li class="basic-info-item">
          <mat-icon class="notranslate dollar-sign">attach_money</mat-icon>
          <label>
            Total capitalization:
          </label>
          <span class="value">
            {{ fund.totalCapitalization | terraCurrency }}
            {{ fund.initialCurrency.iso }}
          </span>
        </li>
      </ul>
    </div>
  </section>

  <mat-card class="container tabs-card">
    <nav class="tabs-navigation"
         mat-tab-nav-bar [tabPanel]="tabPanel" mat-stretch-tabs="false" mat-align-tabs="start"> 
      @for (tab of tabs; track tab.route)
      {
        @if(!tab.isHidden)
        {          
          <a mat-tab-link
             [routerLink]="tab.route"
             routerLinkActive #rla="routerLinkActive" [routerLinkActiveOptions]="{ exact: true }"
             [active]="rla.isActive">
            {{tab.label + (rla.isActive && tab.labelBadge !== undefined && tab.labelBadge !== null ? " (" + tab.labelBadge +")" : "")}}
          </a>
        }
      }
    </nav>

    <!-- Tabs content  -->
    <mat-tab-nav-panel #tabPanel>
      <router-outlet (activate)="onActivateChild($event)" />
    </mat-tab-nav-panel>

  </mat-card>
</ng-container>
